module.exports = __webpack_public_path__ + "static/media/r-bahn.99298263.svg";